export enum ServiceAddFeeType {
    Normal = 1,
    Hierarchy = 2,
    Min = 3
}